import { type TooltipProps } from '@shipt/design-system-tooltip'
import { lazy, Suspense, useState } from 'react'

const DynamicTooltip = lazy(() =>
  import('@shipt/design-system-tooltip').then((module) => ({
    default: module.Tooltip,
  })),
)

export const WithTooltip = ({ children, message, placement }: TooltipProps) => {
  const [hovered, setHovered] = useState(false)

  if (hovered) {
    return (
      // Suspense and fallback are used to render the children while the Tooltip
      // component is being loaded to avoid any layout shifts.
      <Suspense fallback={children}>
        <DynamicTooltip message={message} placement={placement}>
          {children}
        </DynamicTooltip>
      </Suspense>
    )
  }
  return (
    <div onFocus={() => setHovered(true)} onPointerEnter={() => setHovered(true)}>
      {children}
    </div>
  )
}
